module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightbulb-off-636bce2e.svg";